import { ChangeEvent, FormEvent, MouseEvent, useContext, useState } from 'react';
import { IFulfilment } from '../../../interface/FulfilmentInterface';
import { endpoints } from '../../../utils/URL';
import axios from 'axios';
import { AppContext } from '../../../context/AppContext';
import { IAppState } from '../../../interface/AppInterface';
import { isFormValidated } from '../../../utils/formUtils';
import { NairaSymbol } from '../../../utils/mappings';
import { formatDateTime } from '../../../utils/dateTimeUtils';
import Details from './Details';

const Fulfilments = () => {
  const [fulfilments, setFulfilments] = useState<IFulfilment[]>([]);
  const [selected, setSelected] = useState<IFulfilment | undefined>();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [openModal, setOpenModal] = useState<boolean>(false);

  const { appState }: { appState: IAppState } = useContext(AppContext);

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event: FormEvent<HTMLButtonElement>) => {
    if (!isFormValidated('fulfilment-search')) {
      return;
    }

    event.preventDefault();
    getFulfilments(searchTerm);
  };

  const openDetails = (fulfilment: IFulfilment) => (event: MouseEvent<HTMLDivElement>) => {
    // open details modal
    setSelected(fulfilment);
    setOpenModal(true);
  };

  const getStatusIcon = (fulfilmentStatus: string) => {
    switch (fulfilmentStatus) {
      case 'Cancelled':
        return 'bi bi-x-circle-fill text-danger fw-900 ms-1';
      case 'Completed':
        return 'bi bi-check-circle-fill text-success fw-900 ms-1';
      case 'Approved':
        return 'bi bi-check-circle text-success fw-900 ms-1';
      case 'Dispensed':
        return 'bi bi-check2-all text-info fw-900 ms-1';
      case 'Processing':
        return 'bi bi-hourglass-split text-info fw-900 ms-1';
      default:
        return 'bi bi-hourglass text-info fw-900 ms-1';
    }
  };

  const getFulfilments = async (searchQuery: string) => {
    const url = `${endpoints.fulfilments.mainUrl}/${appState.pharmacyCode}/search?searchQuery=${searchQuery}`;

    try {
      const response = await axios.get(url);
      const data = response.data as IFulfilment[];
      setFulfilments(data);
    } catch (error) {
      console.error('Error fetching fulfilments:', error);
    }
  };

  return (
    <div className='container-fluid my-5 content-section'>
      <Details
        show={openModal}
        close={() => setOpenModal(!openModal)}
        data={selected}
        callback={() => getFulfilments(searchTerm)}
      />
      <div className='row'>
        {/* search bar */}
        <form
          id='fulfilment-search'
          className='col-md-6 mx-auto align-items-center d-flex justify-space-between gap-2'
        >
          <input
            type='text'
            onChange={handleSearch}
            className='form-control'
            required={true}
            name='searchTerm'
            value={searchTerm}
            placeholder='Search using phone number or enrollee ID...'
          />
          <button type='submit' className='btn btn-primary px-2 px-sm-5' onClick={handleSubmit}>
            Search
          </button>
        </form>
        {/* search results as cards? */}

        {fulfilments.length > 0 && (
          <div className='search-results mt-5 col-sm-12 mx-auto'>
            <div className='row justify-content-center'>
              {fulfilments.map((fulfilment) => (
                <div key={fulfilment.requestId} className='col-sm-5'>
                  <div className='card card-shadow' onClick={openDetails(fulfilment)}>
                    <div className='card-body p-4'>
                      <div className='d-flex justify-content-between align-items-center'>
                        <div className='card-title fw-600'>
                          <span className='bi bi-person me-1'></span>
                          {fulfilment.patientName}
                        </div>
                        <div className='card-title fw-300 fs-14'>
                          {fulfilment.fulfilmentStatus}
                          <span className={getStatusIcon(fulfilment.fulfilmentStatus)}></span>
                        </div>
                      </div>

                      <div className='d-flex justify-content-between align-items-middle mt-3'>
                        <div>{fulfilment.enrollmentCode}</div>
                        <div>{fulfilment.enrolleePhone}</div>
                      </div>

                      <div className='d-flex justify-content-between align-items-middle mt-3'>
                        <div className='fw-600 fs-18'>
                          {NairaSymbol}
                          {fulfilment.drugs
                            .reduce((acc, drug) => acc + drug.cost * drug.quantity, 0)
                            .toLocaleString()}
                        </div>
                        <div className='fs-14 fw-300'>{formatDateTime(fulfilment.dateCreated)}</div>
                      </div>
                      {/* <button className='btn btn-primary'>View Details</button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Fulfilments;
